import { render } from "./AndroidMonitoring.vue?vue&type=template&id=2fd65867&scoped=true"
import script from "./AndroidMonitoring.vue?vue&type=script&lang=js"
export * from "./AndroidMonitoring.vue?vue&type=script&lang=js"

import "./AndroidMonitoring.vue?vue&type=style&index=0&id=2fd65867&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd65867"]])

export default __exports__